import i18n from 'services/i18n'

const BASE_ROUTES = {
  Administrator: `/${i18n('PAGE_COURSES')}`,
  Instructor: `/${i18n('PAGE_COURSES')}`,
  Leader: `/${i18n('PAGE_DASHBOARD')}`
}

export default BASE_ROUTES
